// Items not configured per environment
const defaultConfig = {}

export default {...defaultConfig, ...window.ENV}
